"use client";

import { useEffect } from "react";

interface ErrorDisplayProps {
  error: Error & { digest?: string };
  reset: () => void;
  section?: string;
}

export default function ErrorDisplay({ error, reset, section }: ErrorDisplayProps) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
      }}
    >
      <div
        style={{
          maxWidth: "480px",
          width: "100%",
          background: "var(--color-surface, #202124)",
          border: "1px solid rgba(242, 139, 130, 0.25)",
          borderRadius: "12px",
          padding: "2rem",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "48px",
            height: "48px",
            borderRadius: "50%",
            background: "rgba(242, 139, 130, 0.12)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 1.25rem",
            fontSize: "1.5rem",
          }}
        >
          ⚠
        </div>

        <h2
          style={{
            fontSize: "1.1rem",
            fontWeight: 700,
            color: "var(--color-text-primary, #e8eaed)",
            marginBottom: "0.5rem",
          }}
        >
          {section ? `${section} failed to load` : "Something went wrong"}
        </h2>

        <p
          style={{
            fontSize: "0.875rem",
            color: "var(--color-text-secondary, #9aa0a6)",
            marginBottom: "1.5rem",
            lineHeight: 1.5,
          }}
        >
          {error.message || "An unexpected error occurred. Try refreshing the page."}
        </p>

        <div style={{ display: "flex", gap: "0.75rem", justifyContent: "center" }}>
          <button
            onClick={reset}
            style={{
              padding: "0.5rem 1.25rem",
              borderRadius: "8px",
              border: "none",
              background: "var(--color-primary, #8ab4f8)",
              color: "#131314",
              fontSize: "0.875rem",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Try again
          </button>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "0.5rem 1.25rem",
              borderRadius: "8px",
              border: "1px solid var(--color-border, #3c4043)",
              background: "transparent",
              color: "var(--color-text-secondary, #9aa0a6)",
              fontSize: "0.875rem",
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            Reload page
          </button>
        </div>

        {error.digest && (
          <p
            style={{
              marginTop: "1rem",
              fontSize: "0.75rem",
              color: "var(--color-text-muted, #5f6368)",
              fontFamily: "monospace",
            }}
          >
            Error ID: {error.digest}
          </p>
        )}
      </div>
    </div>
  );
}
